import { useRouter } from 'next/router';
import React from 'react';
import DashboardPage from '../../../components/Dashboard/DashboardPage';
import Settings from '../../../components/Dashboard/Settings';
import withApollo from '../../../lib/withApollo';

const SettingsPage = () => {
  const router = useRouter();

  const { open } = router.query;

  return <DashboardPage open={open} label="settings" content={<Settings />} />;
};

export default withApollo(SettingsPage);
